<app-toast [message]="toast.message"></app-toast>

<div class="row">

  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    <app-loading [condition]="isLoading.organization"></app-loading>
    @if (!isLoading.organization) {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Third party <app-breadcrumb [menuItems]="menuItems" [currentContent]="currentContent"></app-breadcrumb>
        </h4>
        <div class="card-body pb-0">
          <div class="row row-cols-1 row-cols-lg-2">
            <div class="col mb-3 pr-lg-1">
              <app-organization [organization]="organization"></app-organization>
            </div>
            <div class="col mb-3">
              <div class="card h-100">
                <div class="card-body">
                  <h5 class="card-title">
                    Website
                    <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-organization-details-modal" (click)="toggleEditOrganizationDetailsModal('website')">
                      <i class="fa fa-pencil"></i> Edit
                    </button>
                  </h5>
                  @if (organization.website) {
                    <div>
                      <i class="fa fa-globe me-1"></i>
                      <a [href]="organization.website" target="_blank">{{organization.website}}</a>
                    </div>
                  }
                  @if (!organization.website) {
                    <div>Nothing found.</div>
                  }

                  <h5 class="card-title mt-3">
                    Socials
                    <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-organization-details-modal" (click)="toggleEditOrganizationDetailsModal('socials')">
                      <i class="fa fa-pencil"></i> Edit
                    </button>
                  </h5>
                  <div>
                    <app-socials [item]="organization" side="left" text="yes"></app-socials>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row row-cols-1 row-cols-lg-2">
            <div class="col mb-3 pr-lg-1">
              <div class="card h-100">
                <div class="card-body">
                  <h5 class="card-title">
                    Notes
                    <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-organization-details-modal" (click)="toggleEditOrganizationDetailsModal('notes')">
                      <i class="fa fa-pencil"></i> Edit
                    </button>
                  </h5>
                  @if (organization.notes) {
                    <div>
                      <p [innerHTML]="formatNotes(organization.notes)"></p>
                    </div>
                  }
                  @if (!organization.notes) {
                    <div>Nothing found.</div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    <div class="card border-0" [hidden]="currentContent !== 'track-record'">
      <h4 class="card-header border-0">
        Track record
      </h4>
      <div class="card-body">
        @if (!isLoading.records && records?.length) {
          <p>
            <span class="badge badge-primary">{{count}}</span> results found:
          </p>
        }
        @if (isLoading.records === false && records?.length === 0) {
          <p>Nothing found.</p>
        }
        @if (isLoading.records) {
          <p>
            <app-spinner [condition]="isLoading.records"></app-spinner>
          </p>
        }
        @if (records?.length) {
          <div class="row row-cols-1 row-cols-lg-2" [ngClass]="{ 'disabled': isLoading.records }">
            @for (record of records; track record) {
              <div class="col mb-3">
                <app-record [record]="record" [organizations]="organizations"></app-record>
              </div>
            }
          </div>
        }
        @if (records?.length) {
          <div>
            <app-pagination [isLoading]="isLoading.records" [count]="count" [perPage]="perPage" [page]="page" eventName="getRecords"></app-pagination>
            <app-spinner [condition]="isLoading.records"></app-spinner>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<app-edit-organization-details-modal [hidden]="!isEditOrganizationDetailsModalVisible" [field]="field" [organization]="organization"></app-edit-organization-details-modal>
